// navItems.js

import AuthService from "../admin/components/util/AuthService";


const buildMenuItems = () => {

    const user = AuthService.getUserData();
    const selectedCompany = user?.companies?.find(c => c.selected === 1) || user?.companies?.[0];

    const valided = (types = [], checkManager = false) => {

        const isUserTypeValid = types.includes(user?.users_type_id);
        const isManagerValid = checkManager && user?.users_type_id === 1 ? selectedCompany?.managers?.length > 0 : true;


        return isUserTypeValid && isManagerValid;
    };


    const rawMenu = [
        {
            label: "Menu",
            isHeader: true,
        },
        {
            id: "dashboard",
            label: "Home",
            icon: "fa-solid fa-house",
            link: "/#",
            stateVariables: false, // Initial state, will be managed in Navdata
            subItems: [
                {
                    id: "dashboards",
                    label: "Dashboards",
                    link: "/admin/dashboard",
                    parentId: "dashboard",
                    isManagers: false,
                    isUserstypeId: [1, 2, 3, 7, 8]
                }
            ]
        },
        {
            id: "Duty",
            label: "Plantões",
            icon: "fa-solid fa-user-clock",
            link: "/#",
            stateVariables: false, // Initial state, will be managed in Navdata
            subItems: [
                {
                    id: "dutyregister",
                    label: "Cadastro",
                    link: "/admin/duty-register",
                    parentId: "Duty",
                    isManagers: false,
                    isUserstypeId: [1, 2, 3, 7]

                },
                {
                    id: "dutycalendar",
                    label: "Calendário",
                    link: "/admin/duty-calendar",
                    parentId: "Duty",
                    isManagers: true,
                    isUserstypeId: [1, 2, 3, 7, 8]

                },
                {
                    id: "dutycalendar",
                    label: "Verificação Biométrica",
                    link: "/admin/presence-check",
                    parentId: "Duty",
                    isManagers: true,
                    isUserstypeId: [1, 2, 3, 7]

                },
                {
                    id: "dutymy",
                    label: "Meus",
                    link: "/admin/duty-my",
                    parentId: "Duty",
                    isManagers: false,
                    isUserstypeId: [1, 7]
                },
                {
                    id: "dutysearch",
                    label: "Disponíveis",
                    link: "/admin/duty-search",
                    parentId: "Duty",
                    isManagers: false,
                    isUserstypeId: [1, 7]
                },
                {
                    id: "dutyapprovedutyexchange",
                    label: "Aprovar Troca",
                    link: "/admin/duty-approve-duty-exchange",
                    parentId: "Duty",
                    isManagers: false,
                    isUserstypeId: [1, 7]
                }, {
                    id: "dutyApproveManagers",
                    label: "Aprovar Plantão",
                    link: "/admin/duty-approve-managers",
                    parentId: "Duty",
                    isManagers: true,
                    isUserstypeId: [1, 7]
                },
                {
                    id: "dutycontrol",
                    label: "Controle",
                    link: "/admin/duty-control",
                    parentId: "Duty",
                    isManagers: false,
                    isUserstypeId: [7, 8]
                },
                {
                    id: "dutyranking",
                    label: "Relatório Ranking",
                    link: "/admin/duty-ranking",
                    parentId: "Duty",
                    isManagers: true,
                    isUserstypeId: [1, 2, 3, 7]
                }
            ]
        },
        {
            id: "Scale",
            label: "Escala Padrão",
            icon: "fa-solid fa-calendar-days",
            link: "/#",
            stateVariables: false, // Initial state, will be managed in Navdata
            subItems: [
                {
                    id: "Scale",
                    label: "Dashboard",
                    link: "/admin/scale-dashboard",
                    parentId: "Scale",
                    isManagers: true,
                    isUserstypeId: [1, 2, 3, 7]
                },
                {
                    id: "ScaleRegister",
                    label: "Cadastro",
                    link: "/admin/scale-register",
                    parentId: "Scale",
                    isManagers: true,
                    isUserstypeId: [1, 2, 3, 7]
                },
                {
                    id: "ScaleConfig",
                    label: "Configurar",
                    link: "/admin/scale-config",
                    parentId: "Scale",
                    isManagers: true,
                    isUserstypeId: [1, 2, 3, 7]
                },
                {
                    id: "ScaleAssignment",
                    label: "Histórico Gerar Plantão ",
                    link: "/admin/scale-posting",
                    parentId: "Scale",
                    isManagers: true,
                    isUserstypeId: [1, 2, 3, 7]
                },

            ]
        },
        {
            id: "Marketing",
            label: "Marketing",
            icon: "fa-solid fa-bullhorn me-2",
            link: "/#",
            stateVariables: false,
            subItems: [
                {
                    id: "Lead",
                    label: "Lead",
                    link: "/admin/lead",
                    parentId: "Marketing",
                    isManagers: false,
                    isUserstypeId: [7]
                }
            ]
        },
        {
            id: "Financial",
            label: "Financeiro",
            icon: "fa-solid fa-file-invoice-dollar",
            link: "/#",
            stateVariables: false, // Initial state, will be managed in Navdata
            subItems: [
                // {
                //     id: "affiliates",
                //     label: "Afiliados",
                //     link: "/admin/affiliates",
                //     parentId: "Financial",
                //     isManagers: false,
                //     isUserstypeId: [1, 2, 3, 7]
                // },
                {
                    id: "extractlist",
                    label: "Extrato",
                    link: "/admin/extract",
                    parentId: "Financial",
                    isManagers: false,
                    isUserstypeId: [1, 7]
                },
                {
                    id: "extractManagerslist",
                    label: "Extrato Gestores",
                    link: "/admin/extract-managers",
                    parentId: "Financial",
                    isManagers: true,
                    isUserstypeId: [1, 2, 3, 7, 8]
                },
                // {
                //     id: "plan",
                //     label: "Plano",
                //     link: "/admin/plan",
                //     parentId: "Financial",
                //     isManagers: false,
                //     isUserstypeId: [1, 7]
                // },
            ]
        },
        {
            id: "Accreditation",
            label: "Credenciamentos",
            icon: "fa-solid fa-user-doctor",
            link: "/#",
            stateVariables: false, // Initial state, will be managed in Navdata
            subItems: [
                {
                    id: "accreditationusers",
                    label: "Empresas",
                    link: "/admin/accreditation-users",
                    parentId: "accreditation",
                    isManagers: false,
                    isUserstypeId: [1, 7]
                },
                {
                    id: "accreditationcompany",
                    label: "Usuários",
                    link: "/admin/accreditation-company",
                    parentId: "accreditation",
                    isManagers: false,
                    isUserstypeId: [2, 3, 7]
                },
                {
                    id: "accreditationUserAvaliable",
                    label: "Avaliação de Usuários",
                    link: "/admin/managers-user-available",
                    parentId: "accreditation",
                    isManagers: true,
                    isUserstypeId: [1, 2, 3, 7]
                }
            ]
        },
        {
            id: "Notification",
            label: "Notificações",
            icon: "fa-solid fa-bell",
            link: "/#",
            stateVariables: false, // Initial state, will be managed in Navdata
            subItems: [
                {
                    id: "notificationlist",
                    label: "Notificações",
                    link: "/admin/notification-list",
                    parentId: "Notification",
                    isManagers: false,
                    isUserstypeId: [1, 2, 3, 7]
                }
            ]
        },
        // {
        //     id: "Video",
        //     label: "Vídeo Chamada",
        //     icon: "fa-solid fa-video",
        //     link: "/#",
        //     stateVariables: false,
        //     subItems: [
        //         {
        //             id: "VideoQueue",
        //             label: "Fila de Atendimento",
        //             link: "/admin/video/queue",
        //             parentId: "Video",
        //             isManagers: false,
        //             isUserstypeId: [1, 2, 3, 7]
        //         },
        //         {
        //             id: "VideoCalls",
        //             label: "Atendimentos",
        //             link: "/admin/video/calls",
        //             parentId: "Video",
        //             isManagers: false,
        //             isUserstypeId: [1, 2, 3, 7]
        //         },
        //         {
        //             id: "VideoHistory",
        //             label: "Histórico",
        //             link: "/admin/video/history",
        //             parentId: "Video",
        //             isManagers: false,
        //             isUserstypeId: [1, 2, 3, 7]
        //         },
        //         {
        //             id: "VideoClients",
        //             label: "Clientes",
        //             link: "/admin/video/clients",
        //             parentId: "Video",
        //             isManagers: false,
        //             isUserstypeId: [1, 2, 3, 7]
        //         },
        //         {
        //             id: "VideoDepartments",
        //             label: "Departamentos",
        //             link: "/admin/video/departments",
        //             parentId: "Video",
        //             isManagers: false,
        //             isUserstypeId: [2, 3, 7]
        //         },
        //         {
        //             id: "VideoAttendees",
        //             label: "Atendentes",
        //             link: "/admin/video/attendees",
        //             parentId: "Video",
        //             isManagers: false,
        //             isUserstypeId: [2, 3, 7]
        //         },
        //         {
        //             id: "VideoStats",
        //             label: "Estatísticas",
        //             link: "/admin/video/stats",
        //             parentId: "Video",
        //             isManagers: false,
        //             isUserstypeId: [2, 3, 7]
        //         }
        //     ]
        // },
        {
            id: "Config",
            label: "Configurações",
            icon: "fa-solid fa-gear",
            link: "/#",
            stateVariables: false, // Initial state, will be managed in Navdata
            subItems: [
                {
                    id: "ConfigDepartment",
                    label: "Departamentos",
                    link: "/admin/department",
                    parentId: "Config",
                    isManagers: false,
                    isUserstypeId: [2, 3, 7]
                },
                {
                    id: "ConfigSpecialties",
                    label: "Especialidades",
                    link: "/admin/specialties",
                    parentId: "Config",
                    isManagers: false,
                    isUserstypeId: [2, 3, 7]
                },
                {
                    id: "ConfigOfficer",
                    label: "Funcionários",
                    link: "/admin/officer",
                    parentId: "Config",
                    isManagers: false,
                    isUserstypeId: [2, 3, 7]
                },
                {
                    id: "ConfigManagers",
                    label: "Gestores",
                    link: "/admin/managers",
                    parentId: "Config",
                    isManagers: false,
                    isUserstypeId: [2, 3, 7]
                },
                {
                    id: "ConfigImport",
                    label: "Importações",
                    link: "/admin/import",
                    parentId: "Config",
                    isManagers: true,
                    isUserstypeId: [1, 2, 3, 7]
                },
                {
                    id: "ConfigHospital",
                    label: "Locais",
                    link: "/admin/location",
                    parentId: "Config",
                    isManagers: true,
                    isUserstypeId: [1, 2, 3, 7]
                },
                {
                    id: "ConfigPreferences",
                    label: "Preferência",
                    link: "/admin/preferences",
                    parentId: "Config",
                    isManagers: true,
                    isUserstypeId: [2, 3, 7]
                },
                {
                    id: "WhiteLabel",
                    label: "White Label",
                    link: "/admin/white-label",
                    parentId: "Config",
                    isManagers: false,
                    isUserstypeId: [8]
                }
            ]
        }, {
            id: "help",
            label: "Ajuda",
            icon: "fa-solid fa-circle-info",
            link: "/#",
            stateVariables: false, // Initial state, will be managed in Navdata
            subItems: [
                {
                    id: "notificationlist",
                    label: "Guia do Usuário",
                    link: "/admin/user-guide",
                    parentId: "help",
                    isManagers: false,
                    isUserstypeId: [1, 2, 3, 7]
                }, {
                    id: "ConfigHelpDesk",
                    label: "Help Desk",
                    link: "/admin/help-desk",
                    parentId: "help",
                    isManagers: true,
                    isUserstypeId: [1, 2, 3, 7]
                }
            ]
        }
    ];


    const filteredMenu = rawMenu
        .map(item => {
            // Se não tiver subItems, mantém o item como está (ex: headers)
            if (!item.subItems) return item;

            // Filtra os subItens válidos conforme a função valided
            const validSubItems = item.subItems.filter(sub =>
                valided(sub.isUserstypeId || [], sub.isManagers || false)
            );

            // Se tiver subitens válidos, retorna o item com os subitens filtrados
            if (validSubItems.length > 0) {
                return {...item, subItems: validSubItems};
            }

            // Caso não tenha subitens válidos, retorna null para ser filtrado depois
            return null;
        })
        .filter(Boolean); // Remove os nulls (itens sem subitens válidos)

    return filteredMenu;

};


export const menuItems = buildMenuItems();